/**
 * UI permission-keys for the `CLIENT` route (Clients screen).
 * Typed mirror of the BE CSV — confirm strings with the BE. (ENT-89 T15.)
 */
export const ClientAclKeys = {
  /** Access to the /clients listing + detail subtree. */
  listingRead: 'clients:listing:read',
  /** Onboard Client — gates BOTH the launcher button and the /onboarding/client route. */
  onboard: 'clients:onboard',
} as const;

export type ClientAclKey = (typeof ClientAclKeys)[keyof typeof ClientAclKeys];
